import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

/**
 * The route for the admin pages - global access management page.
 */
export const adminPagesGlobalAccessManagementRoute: InvariantJiraRoute = {
	name: 'global-settings-system-access-management',
	path: '/jira/settings/system/access-management',
	exact: true,
};
